/** Logo tab — where the mark sits and how loud it is. Four sliders; the rest
 *  of the logo's world (source, swap, aspect) lives in More options. */
import type { StudioInspectorProps } from "../../StudioInspector.tsx";
import { SliderRow } from "../essentials/index.ts";

export function LogoTab({ inspector }: { inspector: StudioInspectorProps }): React.JSX.Element {
  const { layout, onPreview, onCommit } = inspector;
  const logo = layout.logo;
  return (
    <>
      <SliderRow
        label="Size" value={logo.widthPct} min={4} max={90} step={1} unit="%"
        toPatch={(v) => ({ layout: { logo: { widthPct: v } } })} commitLabel="Logo size"
        onPreview={onPreview} onCommit={onCommit}
      />
      <SliderRow
        label="Horizontal position" value={logo.xPct} min={0} max={100} step={0.5} unit="%"
        toPatch={(v) => ({ layout: { logo: { xPct: v } } })} commitLabel="Logo position"
        onPreview={onPreview} onCommit={onCommit}
      />
      <SliderRow
        label="Space from the bottom" value={logo.bottomPx} min={0} max={3640} step={10} unit="px"
        toPatch={(v) => ({ layout: { logo: { bottomPx: v } } })} commitLabel="Logo bottom space"
        onPreview={onPreview} onCommit={onCommit}
      />
      <SliderRow
        label="Opacity" value={logo.opacity} min={0} max={1} step={0.05}
        toPatch={(v) => ({ layout: { logo: { opacity: v } } })} commitLabel="Logo opacity"
        onPreview={onPreview} onCommit={onCommit}
      />
    </>
  );
}
